import { render, staticRenderFns } from "./ReprocessarImportacaoModal.vue?vue&type=template&id=5f778fdc"
import script from "./ReprocessarImportacaoModal.vue?vue&type=script&lang=js"
export * from "./ReprocessarImportacaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports